module.exports = __webpack_public_path__ + "static/media/coalesse-thumbnail.498aa1ed.jpg";